<template>
  <div class="content forumList">
    <div class="header">添加幻灯片</div>

    <el-row :gutter="10">
      <el-col :span="2">
        <div class="grid-content align_right">排序：</div>
      </el-col>
      <el-col :span="6">
        <div class="grid-content">
          <template>
            <el-input v-model="sort" placeholder="请输入标题" size="small"></el-input>
          </template>
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="10">
      <el-col :span="2">
        <div class="grid-content align_right">标题：</div>
      </el-col>
      <el-col :span="6">
        <div class="grid-content">
          <template>
            <el-input v-model="title" placeholder="请输入标题" size="small"></el-input>
          </template>
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="10">
      <el-col :span="2">
        <div class="grid-content align_right">幻灯片图片：</div>
      </el-col>
      <el-col :span="18">
        <div class="grid-content">
          <el-upload
            action
            list-type="picture-card"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
            :on-change="changeState"
            :file-list="fileList"
            :auto-upload="false"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt />
          </el-dialog>
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="10">
      <el-col :span="2">
        <div class="grid-content align_right">是否显示：</div>
      </el-col>
      <el-col :span="4">
        <div class="grid-content">
          <template>
            <el-radio v-model="isShow" label="1">是</el-radio>
            <el-radio v-model="isShow" label="2">否</el-radio>
          </template>
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="10" class="issue">
      <el-col :span="5" :offset="2">
        <div class="grid-content">
          <el-button size="small" type="primary" @click="issue">提交</el-button>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { addImage } from "@/api/comment";
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data() {
    return {
      upData: [],
      sort: "",
      title: "",
      isShow: "1",
      fileList: [],
      dialogImageUrl: "",
      dialogVisible: false,
      radio: "",
      imageUrl: "", //图片地址
      input: "",
      dataArray: "",
      listData: [] //列表
    };
  },
  mounted() {},
  methods: {
    changeState(file, fileList) {
      console.log(file, fileList);
      let data = new FormData();
      data.append("token", this.token);
      data.append("image", file.raw);
      data.append("type", "1");
      data.append("file_group", "1");
      this.upData.push(data);
      console.log(this.upData);
    },
    // 编辑器
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePictureCardPreview(file) {
      console.log(file);
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    issue() {
      // 问题 上传图片返回的是一个
      let PromiseAll = [],
        imgdata = [];
      for (let i = 0; i < this.upData.length; i++) {
        const element = this.upData[i];
        let prom = new Promise(reloved => {
          addImage(element).then(res => {
            reloved(res);
            console.log(element.get("image"));
          });
        });
        PromiseAll.push(prom);
      }

      Promise.all(PromiseAll).then(result => {
        for (let i = 0; i < result.length; i++) {
          const element = result[i];
          console.log(element.data.url)
          imgdata.push(element.data.url);
        }

        let data = {
          sort: this.sort,
          title: this.title,
          isShow: this.isShow,
          imgdatas: imgdata,
          imgUrl: imgdata[0]
        };
        if (localStorage.getItem("sliceList") == null) {
          localStorage.setItem("sliceList", JSON.stringify([data]));
        } else {
          let localData = JSON.parse(localStorage.getItem("sliceList"));
          localData.push(data);
          localStorage.setItem("sliceList", JSON.stringify(localData));
        }
        this.$router.push({
          path: "/apply/forum/18/lanternSlide"
        });
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.content {
  padding: 0 55px 30px 0;
  height: calc(100vh - 102px);
  border: 1px solid #f1f1f1;
  overflow: auto;
  min-width: 900px;
  // box-shadow: 0 0 3px #f1f1f1;
}
.forumList {
  padding: 10px 25px;
  .header {
    border-bottom: 0;
    background-color: #f8f8f8;
    position: relative;
    padding-left: 24px;
    margin-bottom: 15px;
    padding: 10px 15px;
  }
  .header:after {
    content: "";
    position: absolute;
    width: 4px;
    height: 16px;
    background: #1ab394;
    border-radius: 30%;
    top: 50%;
    left: 10px;
    margin-top: -8px;
  }
  .grid-content {
    min-width: 80px;
    min-height: 32px;
    line-height: 32px;
  }
  .align_right {
    text-align: right;
    font-size: 14px;
  }
  .el-row {
    margin-bottom: 30px;
  }
  .issue {
    padding: 10px 0 30px;
  }
}
</style>

<style lang="scss">
.forumList {
  .editor {
    width: 100%;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
}
</style>